import React from 'react';
import { cn } from '@/lib/utils';
import {
  getMenuAccentColor,
  getMenuBannerOverlayStyle,
  getMenuBranding,
  isPremiumMenu,
} from '@/lib/menuTheme';
import { formatScheduleForCustomer } from '@/lib/weeklySchedule';
import { Clock } from 'lucide-react';

/** Banner compacto del local sobre el chat del asistente. */
export function AssistantLocalBanner({ business }) {
  if (!business) return null;

  const premium = isPremiumMenu(business);
  const branding = getMenuBranding(business);
  const accent = getMenuAccentColor(business);
  const schedulePreview = formatScheduleForCustomer(business);
  const shortSchedule =
    schedulePreview && schedulePreview.includes('\n')
      ? `${schedulePreview.split('\n')[0]} · …`
      : schedulePreview;

  return (
    <div className="shrink-0 relative w-full overflow-hidden border-b">
      {business.banner_url ? (
        <div className="relative h-28 sm:h-32 w-full">
          <img
            src={business.banner_url}
            alt=""
            className={cn('h-full w-full object-cover', premium && 'scale-105')}
          />
          {premium ? (
            <div
              className="pointer-events-none absolute inset-0"
              style={getMenuBannerOverlayStyle(business)}
              aria-hidden
            />
          ) : (
            <div
              className="pointer-events-none absolute inset-0 bg-gradient-to-t from-background/95 via-background/40 to-black/30"
              aria-hidden
            />
          )}
        </div>
      ) : (
        <div className="h-20 w-full" style={{ backgroundColor: accent }} aria-hidden />
      )}

      <div
        className={cn(
          'px-4 py-3',
          business.banner_url ? 'absolute bottom-0 left-0 right-0 bg-gradient-to-t from-background via-background/90 to-transparent' : '',
        )}
      >
        <div className="flex items-center gap-3 max-w-4xl mx-auto">
          {business.logo_url ? (
            <div className="h-11 w-11 shrink-0 rounded-full overflow-hidden border-2 border-background shadow-md">
              <img src={business.logo_url} alt="" className="h-full w-full object-cover" />
            </div>
          ) : null}
          <div className="min-w-0 flex-1">
            <h2
              className="font-semibold text-base truncate"
              style={premium ? { color: branding.text_color } : undefined}
            >
              {business.name}
            </h2>
            {shortSchedule ? (
              <p className="text-xs text-muted-foreground flex items-center gap-1 mt-0.5 truncate">
                <Clock className="w-3 h-3 shrink-0" />
                <span className="truncate">{shortSchedule}</span>
              </p>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
